import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bf4f67ec&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bf4f67ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4f67ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf4f67ec')) {
      api.createRecord('bf4f67ec', component.options)
    } else {
      api.reload('bf4f67ec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bf4f67ec&scoped=true", function () {
      api.rerender('bf4f67ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/retailer/order/detail/index.vue"
export default component.exports